import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

const TOKEN_LENGTH = 22;

export default function HelcimPayIframe({
  token,
  phone,
  email,
  csrf,
  onClose,
}) {
  const iframeContainerRef = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token || token === "undefined" || token.length !== TOKEN_LENGTH) {
      toast?.error("Invalid checkout token.");
      return;
    }

    const dev =
      window.location.hostname.endsWith(".helcim.test") ||
      window.location.hostname.endsWith(".myhelcim.test");

    const domain = dev ? "secure-app.helcim.test" : "secure.helcim.app";

    const queryParams = new URLSearchParams();
    queryParams.append("allowExit", "");
    if (phone) queryParams.append("phone", phone);
    if (email) queryParams.append("email", email);

    const url = `${
      window.location.protocol
    }//${domain}/helcim-pay/${token}?${queryParams.toString()}`;

    setLoading(true);

    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.name = csrf;
    iframe.id = "helcimPayIframe";
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.frameBorder = "0";
    iframe.style = `
      position: fixed;
      top: 0; left: 0;
      width: 100%;
      height: 100%;
      border: none;
      z-index: 998;
    `;

    iframeContainerRef.current?.appendChild(iframe);

    // Fallback timer to hide loader after 10s if READY never received
    const fallbackTimeout = setTimeout(() => {
      console.warn(
        "⚠️ Fallback: iframe did not send READY, hiding loader after 10s"
      );
      setLoading(false);
    }, 5000);

    const watchForMessages = (event) => {
      const data = event?.data;
      if (!data || typeof data !== "object") return;

      // Handle READY event from iframe
      if (data.eventStatus === "READY") {
        setLoading(false);
        clearTimeout(fallbackTimeout);
      }

      // Handle HIDE event from iframe
      if (data.eventStatus === "HIDE") {
        iframe.remove();
        window.removeEventListener("message", watchForMessages);
        clearTimeout(fallbackTimeout);
        if (onClose) onClose();
      }

      console.log(data, "datadatadata");
    };

    window.addEventListener("message", watchForMessages);

    return () => {
      iframe.remove();
      window.removeEventListener("message", watchForMessages);
      clearTimeout(fallbackTimeout);
    };
  }, [token, phone, email, csrf, onClose]);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.85)",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          Loading secure payment...
        </div>
      )}
      <div ref={iframeContainerRef} />
    </>
  );
}
